export default __webpack_public_path__ + "static/media/foreign-book-background-2.8d693a00.png";